import {css} from 'styled-components';

const Select2 = css`

    .select2-container .select2-selection--single {
        height: 40px;
        border-color: #ccc;
    }
    
    .select2-container--default .select2-selection--single .select2-selection__arrow,
    .react-autosuggest__input {
        height: 40px;
    }
    
    .select2-container--default .select2-selection--single .select2-selection__rendered {
        line-height: 40px;
    }
    
    .react-autosuggest__input {
    border-color: #ccc;
    }
    
    .react-autosuggest__suggestions-container--open {
        top: 38px;
        width: 100%;
    }
	

`;

export default Select2;


// WEBPACK FOOTER //
// ./src/app/components/styled/global/select2.js